<div class="modal-header">
  <div class="d-flex align-items-center gap-3 w-100">
    <div class="d-flex gap-2 align-items-center">
      <div class="modal-title" i18n>Add LOS Discount</div>
      <app-page-help articleId="140pvl2gk2"></app-page-help>
    </div>
    <div class="flex-fill"></div>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body bg-none p-0 m-0">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="p-3">
      <div class="row">
        <div class="col-md-6">
          <label class="form-field-label">
            <ng-container i18n>Type</ng-container> <span class="text-danger">*</span>
          </label>
          <div class="d-flex gap-3">
            <button
              class="btn flex-1"
              (click)="form.get('type').setValue('flat')"
              [ngClass]="form.get('type').value == 'flat' ? 'btn-success' : 'btn-outline-success'"
              matTooltip="Exact value set in Amount field will be discounted from booking total"
              i18n-matTooltip
            >
              <i class="fas fa-dollar-sign"></i> <ng-container i18n>Flat</ng-container>
            </button>
            <button
              class="btn flex-1"
              (click)="form.get('type').setValue('pct')"
              [ngClass]="form.get('type').value == 'pct' ? 'btn-info' : 'btn-outline-info'"
              matTooltip="Percentage of booking total will be discounted"
              i18n-matTooltip
            >
              <i class="fas fa-percent"></i> <ng-container i18n>Percentage</ng-container>
            </button>
          </div>
        </div>
        <div class="col-md-6">
          <mat-form-field2
            class="d-block"
            matTooltip="Enter the name for this discount"
            matTooltipPosition="below"
            i18n-matTooltip
          >
            <input matInput placeholder="Name" i18n-placeholder formControlName="name" type="text" required />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('maxlength')" i18n>
              Name must be at most 50 characters
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('allWhitespace')" i18n> Name is invalid </mat-error>
            <mat-hint align="end"> {{ form.get('name').value.length || 0 }}/50</mat-hint>
          </mat-form-field2>
        </div>
        <div class="col-md-6" *ngIf="hasModality">
          <label class="form-field-label">
            <ng-container i18n>Modality</ng-container> <span class="text-danger">*</span>
          </label>
          <div class="d-flex gap-3">
            <button
              class="btn flex-1"
              (click)="form.get('modality').setValue(modalities.PerStay)"
              [ngClass]="form.get('modality').value == modalities.PerStay ? 'btn-indigo' : 'btn-outline-indigo'"
              matTooltip="Discount will be applied on Stay as a whole"
              i18n-matTooltip
            >
              <i class="cs-icon cs-icon-bed"></i> <ng-container i18n>Per Stay</ng-container>
            </button>
            <button
              class="btn flex-1"
              (click)="form.get('modality').setValue(modalities.PerNight)"
              [ngClass]="form.get('modality').value == modalities.PerNight ? 'btn-secondary' : 'btn-outline-secondary'"
              matTooltip="Discount will be applied for each night"
              i18n-matTooltip
            >
              <i class="cs-icon cs-icon-moon"></i> <ng-container i18n>Per Night</ng-container>
            </button>
          </div>
        </div>

        <div [ngClass]="hasModality ? 'col-md-6' : 'col-md-12'">
          <mat-form-field2
            class="d-block"
            matTooltip="Enter the description for this discount"
            matTooltipPosition="below"
            i18n-matTooltip
          >
            <textarea
              matInput
              placeholder="Description"
              i18n-placeholder
              formControlName="description"
              type="text"
              rows="2"
              required
              cdkTextareaAutosize
              [cdkAutosizeMaxRows]="3"
            ></textarea>
            <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('required')">
              <ng-container i18n>Description is required</ng-container>
            </mat-error>
            <mat-error i18n *ngIf="form.get('description').hasError('maxlength')">
              Description must be at most 150 characters
            </mat-error>
            <mat-hint align="end"> {{ form.get('description').value.length || 0 }}/150</mat-hint>
          </mat-form-field2>
        </div>
      </div>
    </div>
    <div class="p-3 border-top">
      <div class="row">
        <div class="col-md-3">
          <mat-form-field2
            class="d-block"
            matTooltip="Enter the discount amount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              type="number"
              [placeholder]="amountPlaceholder"
              formControlName="amount"
              required
              step="1"
            />
            <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('percent')">
              <ng-container i18n>Amount should be greater than 0 and less than 100</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('positive')">
              <ng-container i18n>Amount should be greater than 0</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
              <ng-container i18n>Amount is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-3">
          <mat-form-field2
            class="d-block"
            matTooltip="Enter the minimum length of stay to which this discount will be applied"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              type="number"
              placeholder="Length (nights)"
              i18n-placeholder
              formControlName="length"
              required
              step="1"
            />
            <mat-error *ngIf="form.get('length').touched && form.get('length').hasError('min')">
              <ng-container i18n>Length should not be less than 1</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('length').touched && form.get('length').hasError('required')">
              <ng-container i18n>Length is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-3">
          <mat-form-field2
            class="d-block"
            matTooltip="Minimum number of guests required for the discount."
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              type="number"
              placeholder="Guests"
              i18n-placeholder
              formControlName="guests"
              required
              step="1"
            />
            <mat-error *ngIf="form.get('guests').touched && form.get('guests').hasError('min')">
              <ng-container i18n>Max guests should not be less than 1</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('guests').touched && form.get('guests').hasError('required')">
              <ng-container i18n>Max guests is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2
            class="mat-block"
            matTooltip="Select the start date for this discount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              [matDatepicker]="startPicker"
              [max]="maxStartDate.value"
              [min]="this.now"
              placeholder="Start"
              i18n-placeholder
              (focus)="startPicker.open()"
              formControlName="start"
              tabindex="4"
              readonly
            />
            <i matSuffix (click)="startPicker.open()" class="cs-icon cs-icon-calendar"></i>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>

        <div class="col-md-6">
          <mat-form-field2
            class="mat-block"
            matTooltip="Select the end date for this discount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              [matDatepicker]="endPicker"
              [min]="minEndDate.value"
              placeholder="End"
              i18n-placeholder
              (focus)="endPicker.open()"
              formControlName="end"
              tabindex="4"
              readonly
            />
            <i matSuffix (click)="endPicker.open()" class="cs-icon cs-icon-calendar"></i>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="form.get('end').touched && form.get('end').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('end').hasError('matDatepickerMin')">
              <ng-container i18n>Min value is</ng-container>&nbsp;
              <strong>{{ form.get('end').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY' }}</strong>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-rental-select
            [ctrl]="form.get('rentals')"
            [excludeSubunits]="true"
            [matTooltipHideDelay]="item?.rentalsView?.length"
            [matTooltipClass]="isEdit && item.rentals?.length > 20 ? 'text-center tooltip-lg' : 'text-center'"
            [matTooltip]="
              isEdit
                ? item?.rentalsView
                : 'Click here to select the rentals for which this discount will be applied. If no Rental is selected, the discount will apply on all Rental(s)'
            "
            matTooltipPosition="above"
            placeholder="Rental(s)"
            i18n-placeholder
          ></app-rental-select>
        </div>
        <div class="col-md-6">
          <app-select-search
            [items]="channels"
            [ctrl]="form.get('channels')"
            [multiple]="true"
            bindValue="id"
            bindLabel="friendlyName"
            [bindTooltip]="getChannelTooltip"
            [inline]="false"
            [matTooltip]="
              isEdit
                ? item?.channelsView
                : 'Click here to select the channels for which this discount will be applied. If no channel is selected, the discount will apply on all Channel(s)'
            "
            matTooltipPosition="above"
            placeholder="Channel(s)"
            i18n-placeholder
          ></app-select-search>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer border-top">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
